import { type DeferredEditor, deferEditor } from '../shared/deferred-editor'

// Private types ---------------------------------------------------------------

type MarkdownEditorHost = { readonly el: HTMLDivElement }

// Constants -------------------------------------------------------------------

const editors = new WeakMap<MarkdownEditorHost, DeferredEditor>()

// Public hook -----------------------------------------------------------------

export const MarkdownEditor = {
  // Keeps the server preview until an editor near the viewport is ready.
  mounted(this: MarkdownEditorHost): void {
    editors.set(
      this,
      deferEditor(this.el, async () => {
        const { mountEditor } = await import('./engine')

        return () => mountEditor(this.el)
      })
    )
  },

  // Applies enabled state and input ownership after a LiveView patch.
  updated(this: MarkdownEditorHost): void {
    editors.get(this)?.updated()
  },

  // Releases the editor or cancels a download that is still pending.
  destroyed(this: MarkdownEditorHost): void {
    editors.get(this)?.destroy()
    editors.delete(this)
  }
}
